function init() {
	let modalState = {
		modal: '',
		modalWrap: '',
		isOpen: false,
	};

	function initModals() {
		function swithModalOverflow() {
			if (modalState.isOpen === true) {
				document.documentElement.style.overflow = 'hidden';
				document.body.style.overflow = 'hidden';
			} else {
				document.documentElement.style.overflow = 'visible';
				document.body.style.overflow = '';
			}
		}

		function openModal(modalId) {
			const targetModal = $(`[data-remodal-id="${modalId}"]`);
			const modalwrap = $(targetModal).parent('.remodal-bg');

			if (modalState.isOpen === true) {
				modalwrap.addClass('is--unvisible');
				swithModalOverflow();
			}

			modalState.modalWrap = modalwrap;
			modalState.modal = targetModal;
			modalState.isOpen = true;
			swithModalOverflow();

			modalwrap.removeClass('is--unvisible');
		}

		function checkHash() {
			const urlParams = new URLSearchParams(window.location.search);
			const myParam = urlParams.get('idea');

			if (myParam) {
				openModal(`idea${myParam}`);
			}
		}

		function clear() {
			modalState.modalWrap = '';
			modalState.modal = '';
			modalState.isOpen = false;
		}

		function closed() {
			modalState.modalWrap.addClass('is--unvisible');
			clear();
		}

		$('a[data-modal-id]').click(function () {
			const modalId = $(this).attr('data-modal-id');
			openModal(modalId);
		});

		$('[data-open-modal]').click((e) => {
			const modalId = e.currentTarget.getAttribute('data-open-modal');
			closed();
			openModal(modalId);
		});

		$('.remodal').click((e) => {
			e.stopPropagation();
		});

		$('.remodal-bg').click(() => {
			// closed();
			swithModalOverflow();
		});

		$('[data-remodal-action="close"]').click(() => {
			closed();
			swithModalOverflow();
			// resetStatusPopupSliders();
		});

		$(window).on('hashchange', () => {
			checkHash();
		});

		checkHash();
	}

	initModals();
}

export default {
	init,
};
